import Sidebar from './Sidebar'
import SidebarContainer from './SidebarContainer'

export default SidebarContainer(Sidebar)